<div class="liquid-tooltip" [style.top.px]="$coords().top" [style.left.px]="$coords().left">
  <div class="tools">
    @switch ($mode()) {
      @case ('new') {
        <span>
          <button type="button" class="hl-yellow" (click)="createHighlight.emit({ color: 'hl-yellow'})"></button>
        </span>
        <span>
          <button type="button" class="hl-fucsia" (click)="createHighlight.emit({ color: 'hl-fucsia'})"></button>
        </span>
        <span>
          <button type="button" class="hl-light-blue" (click)="createHighlight.emit({ color: 'hl-light-blue'})"></button>
        </span>
        <span>
          <button type="button" class="hl-orange" (click)="createHighlight.emit({ color: 'hl-orange'})"></button>
        </span>
        <span class="divider"></span>
        <span>
          <button type="button" class="icon-file-text" (click)="createNote.emit()"></button>
        </span>
        <span>
          <button type="button" class="icon-link" (click)="createLink.emit()"></button>
        </span>
      }

      @case ('edit-highlight') {
        <span>
          <button type="button" class="hl-yellow" (click)="updateHighlight('hl-yellow')"></button>
        </span>
        <span>
          <button type="button" class="hl-fucsia" (click)="updateHighlight('hl-fucsia')"></button>
        </span>
        <span>
          <button type="button" class="hl-light-blue" (click)="updateHighlight('hl-light-blue')"></button>
        </span>
        <span>
          <button type="button" class="hl-orange" (click)="updateHighlight('hl-orange')"></button>
        </span>
        <span class="divider"></span>
        <span>
          <button type="button" class="icon-trash-2" (click)="deleteAnnotation.emit($annotation())"></button>
        </span>
      }

      @case ('edit-note') {
        <span>
          {{ $annotation()?.title }}
        </span>
        <span class="divider"></span>
        <span>
          <button type="button" class="icon-edit" (click)="openAnnotation.emit($annotation())"></button>
        </span>
        <span>
          <button type="button" class="icon-trash-2" (click)="deleteAnnotation.emit($annotation())"></button>
        </span>
      }

      @case ('edit-link') {
        <span>
          <a [href]="$annotation()?.title" target="_blank" class="link-url">{{ $annotation()?.title }}</a>
        </span>
        <span class="divider"></span>
        <span>
          <button type="button" class="icon-edit" (click)="openAnnotation.emit($annotation())"></button>
        </span>
        <span>
          <button type="button" class="icon-trash-2" (click)="deleteAnnotation.emit($annotation())"></button>
        </span>
      }
    }
  </div>
</div>
